import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCWkQ-Mxbd9Qsdosl7BBAc6jzwT3q9Dljs",
  authDomain: "zetas-pos.firebaseapp.com",
  databaseURL: "https://zetas-pos-default-rtdb.firebaseio.com",
  projectId: "zetas-pos",
  storageBucket: "zetas-pos.appspot.com",
  messagingSenderId: "202728687577",
  appId: "1:202728687577:web:20952d5a52cedf506b7bc8",
  measurementId: "G-36GLV3KLCY",
};

const appService = initializeApp(firebaseConfig, "service");

const authService = getAuth(appService);
const firestoreService = getFirestore(appService, "bcpos");
const storageService = getStorage(appService);

export { authService, firestoreService, storageService };
